module.exports = __webpack_public_path__ + "static/media/draw-happy-birthday.2a6ba915.svg";